import { INPUT_SIZES } from 'cdk-radial';
import { useState, ChangeEvent } from 'react';
import { MAX_LEN } from 'common/constants';
import { StyledInput } from './styled';
import { TextRendererProps, InputSizes } from './types';

export const TextRenderer = ({
  id,
  value,
  handleInputChange,
  disabled
}: TextRendererProps): React.JSX.Element => {
  const [text, setText] = useState(value);
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const description = e.target.value;
    setText(description);
    handleInputChange(description);
  };

  const componentId = id;

  const { SMALL } = INPUT_SIZES as InputSizes;

  return (
    <StyledInput
      data-testid="textRenderer"
      value={text ?? ''}
      onChange={onChange}
      disabled={disabled}
      id={componentId}
      name={componentId}
      label=""
      maxLength={MAX_LEN}
      size={SMALL}
    />
  );
};
